import React from 'react';
import CategoryDTO from '../../../lib/CategoryDTO';
import DocumentDTO from '../../../lib/DocumentDTO';
import Button, { ButtonType } from '../../../../../../../../design/1/js/templates/atoms/button';
import './index.scss';

interface Props {
    categories: CategoryDTO[];
    className?: string;
    documents: DocumentDTO[];
    onSelectCategory: (category: CategoryDTO | null) => void;
    selectedCategory: CategoryDTO | null;
}

const CategoryFilter = ({
    categories,
    className = '',
    documents,
    onSelectCategory,
    selectedCategory,
}: Props) => {
    const baseClassName = 'w-sharedDocumentDownload-categoryFilter';

    return (
        <div className={`${baseClassName} ${className}`}>
            <Button
                active={selectedCategory === null}
                handleClick={() => onSelectCategory(null)}
                hasArrow={false}
                text={`${window.sv_resource.get('shared_document_categories_all')} (${documents.length})`}
                type={ButtonType.Action}
            />
            {categories.map(category => {
                const active = category.id === selectedCategory?.id;

                return (
                    <Button
                        active={active}
                        key={category.id}
                        handleClick={() => onSelectCategory(category)}
                        hasArrow={false}
                        text={`${category.title} (${category.documentCount})`}
                        type={ButtonType.Action}
                    />
                );
            })}
        </div>
    );
};

export default CategoryFilter;
